import { createRoute, redirect } from '@tanstack/react-router';

import { CustomerDetailPage } from '@web/ui/customers/views/customer_detail';

import { orgWorkspaceLayoutRoute } from './overview_routes';

/**
 * `/orgs/$orgSlug/customers/$id` — full-page read-only customer screen.
 *
 * Tab routing mirrors the card_detail `$tab` segment: this parent owns the
 * `customers/$id` path, the index child redirects the bare URL to the default
 * `$tab` (`profile`), and the `$tab` child renders the page for a given tab. The
 * P2 cmd+k navigation still targets `/orgs/$orgSlug/customers/$id` (the parent)
 * — it stays valid because the index child redirects to the default tab.
 */
export const customerRoute = createRoute({
  getParentRoute: () => orgWorkspaceLayoutRoute,
  path: 'customers/$id',
});

/**
 * Index child — redirects the bare `/customers/$id` to the default tab. The
 * redirect lives here, NOT on the parent `beforeLoad`: a parent `beforeLoad`
 * runs for every descendant match, so it would also fire for a direct/refreshed
 * tab URL (`/customers/$id/trips`) and force every tab back to `profile`. The
 * index route matches only the bare path, leaving `$tab` URLs untouched.
 */
export const customerIndexRoute = createRoute({
  getParentRoute: () => customerRoute,
  path: '/',
  beforeLoad: ({ params }) => {
    redirect({
      throw: true,
      to: '/orgs/$orgSlug/customers/$id/$tab',
      params: { ...params, tab: 'profile' },
    });
  },
});

/** `$tab` child — renders the customer screen; the component falls back to `profile`. */
export const customerTabRoute = createRoute({
  getParentRoute: () => customerRoute,
  path: '$tab',
  component: CustomerDetailPage,
});
